import * as React from 'react'
import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  EditButton,
  TopToolbar,
  ListButton,
  ReferenceField,
  useRecordContext,
  NumberField,
  Labeled
} from 'react-admin'
import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Divider
} from '@mui/material'

const ProviderContractShowActions = () => (
  <TopToolbar>
    <ListButton />
    <EditButton />
  </TopToolbar>
)

const PricingTiersField = () => {
  const contract = useRecordContext()
  if (!contract?.pricingTiers || contract.pricingTiers.length === 0) {
    return <Typography variant="body2" color="text.secondary">No pricing tiers configured.</Typography>
  }

  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        B2B Pricing Tiers
      </Typography>
      <Table size="small" sx={{ maxWidth: 600 }}>
        <TableHead>
          <TableRow>
            <TableCell><strong>Min Volume</strong></TableCell>
            <TableCell><strong>Price / Kit Shipped</strong></TableCell>
            <TableCell><strong>Price / Kit Tested</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {contract.pricingTiers.map((tier, i) => (
            <TableRow key={i} hover>
              <TableCell>{tier.minVolume ?? 0}+</TableCell>
              <TableCell>${Number(tier.pricePerKitShipped).toFixed(2)}</TableCell>
              <TableCell>${Number(tier.pricePerKitTested).toFixed(2)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  )
}

const ProviderContractDetails = (props) => {
  return (
    <Show actions={<ProviderContractShowActions />} {...props}>
      <SimpleShowLayout spacing={2} className="details-page-layout">
        <TextField source="id" label="Contract ID" />
        <ReferenceField source="providerGroupId" link="show" reference="provider-groups" label="Provider Group">
          <TextField source="name" />
        </ReferenceField>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
          <Labeled label="Start Date">
            <DateField source="startDate" />
          </Labeled>
          <Labeled label="End Date">
            <DateField source="endDate" />
          </Labeled>
          <Labeled label="Billing Period">
            <TextField source="billingPeriod" sx={{ textTransform: 'capitalize' }} />
          </Labeled>
          <Labeled label="Customer Price">
            <NumberField source="customerPrice" options={{ style: 'currency', currency: 'USD' }} />
          </Labeled>
          <Labeled label="Days to Convert">
            <TextField source="daysToConvert" />
          </Labeled>
        </Box>
        <Divider sx={{ my: 1 }} />
        <PricingTiersField label="Pricing Tiers" />
        <DateField source="createdAt" label="Created At" showTime />
      </SimpleShowLayout>
    </Show>
  )
}

export default ProviderContractDetails
